import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";
import { CommentDataProps } from "./useGetConsoleQrSystemDetail";

interface SuppliesDetailRequest {
    category: string;
    list_no: string;
}

export interface SuppliesDetailResponse {
    // statusCode: number;
    // message: string;
    // data: {
    flag: boolean;
    list_no: number;
    name: string;
    subject: string;
    contents: string;
    company: string;
    mobile: string;
    address: string;
    status: string;
    w_date: string;
    comment: CommentDataProps[];
    // };
}

export const useGetConsoleSuppliesDetail = ({
    category,
    list_no,
}: SuppliesDetailRequest): UseQueryResult<SuppliesDetailResponse, Error> => {
    let url = enum_api_uri.get_console_supplies_detail.replace(":category", category).replace(":list_no", list_no);
    return useQuery({
        queryKey: ["useGetConsoleSuppliesDetail", category, list_no],
        queryFn: async () => {
            const response = await axiosInstance.get(
                url,
                //     {
                //     params: {
                //         category,
                //         list_no,
                //     },
                // }
            );
            return response.data.data;
        },
        enabled: !!category && !!list_no,
    });
};
